import { useNavigate } from "react-router";
import PageLayout from "../../components/PageLayout";
import { CompleteTitleText, OutlineButton } from "./styles";
import CompleteMessageSection from "./sections/CompleteMessageSection";

export default function CompletePage() {
  const navigate = useNavigate();

  return (
    <PageLayout completed>
      <CompleteTitleText>お問い合わせが完了しました。</CompleteTitleText>
      <CompleteMessageSection />
      <OutlineButton type="button" onClick={() => navigate("/")}>
        トップページに戻る
      </OutlineButton>
    </PageLayout>
  );
}
